jQuery(function($) {
	$(document).ready(function() {
		var $btn = $('.fullscreen-btn');
		var $iframe = $('#session-header .video-banner-embed iframe');

		if (!$btn.length || !$iframe.length) {
			return;
		}

		// Build modal markup.
		var $overlay = $('<div class="session-video-modal-overlay"></div>');
		var $modal = $('<div class="session-video-modal"></div>');
		var $close = $('<button class="session-video-modal-close" aria-label="Close">&times;</button>');
		var $container = $('<div class="session-video-modal-container"></div>');

		$modal.append($close, $container);
		$overlay.append($modal);
		$('body').append($overlay);

		// Open modal on button click.
		$btn.on('click', function(e) {
			e.preventDefault();
			// Clone iframe src to avoid autoplay issues.
			var src = $iframe.attr('src');
			// Add autoplay param if not present.
			if (src && src.indexOf('autoplay=') === -1) {
				src += (src.indexOf('?') !== -1 ? '&' : '?') + 'autoplay=1';
			}
			$container.html('<iframe src="' + src + '" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>');
			$overlay.addClass('is-active');
			$('body').css('overflow', 'hidden');
		});

		// Close modal.
		function closeModal() {
			$overlay.removeClass('is-active');
			$container.html('');
			$('body').css('overflow', '');
		}

		$close.on('click', closeModal);

		// Close on overlay click (outside the modal).
		$overlay.on('click', function(e) {
			if ($(e.target).is($overlay)) {
				closeModal();
			}
		});

		// Close on Escape key.
		$(document).on('keydown', function(e) {
			if (e.key === 'Escape' && $overlay.hasClass('is-active')) {
				closeModal();
			}
		});
	});
});
